exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-c264b794]{width:100%;border-collapse:collapse}.reportTbl td[data-v-c264b794]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-c264b794]{text-align:left;line-height:15px}.txtRight[data-v-c264b794]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-c264b794]{text-align:center}.reportTbl tr.tb-td td[data-v-c264b794]{font-weight:700;text-align:center;border:none}td.textCenter[data-v-c264b794]{text-align:center!important}td.textRight[data-v-c264b794]{text-align:right!important}.text-center[data-v-c264b794]{text-align:center!important}.text-bold[data-v-c264b794]{font-weight:700;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c264b794","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/pdf/trainingInformationReport.vue
// module id = 1668
// module chunks = 3